import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns an item in an array by its id.
 *
 * Usage:
 *  'list' | findById: 'id'
 */
@Pipe({
  name: 'findById',
  standalone: true,
})
export class FindByIdPipe implements PipeTransform {
  transform<T extends { id: string }>(value: T[], id: string): T {
    return (value || []).find((item) => item.id === id);
  }
}
